import React, { createContext, ReactNode, useContext } from 'react';
import {
  UseIdleTimerOptions,
  UseIdleTimerReturn,
  useIdleTimer,
} from '../hooks/useIdleTimer';

interface IdleTimerContextValue extends UseIdleTimerReturn {}

const IdleTimerContext = createContext<IdleTimerContextValue | null>(null);

interface IdleTimerProviderProps extends UseIdleTimerOptions {
  children: ReactNode;
}

export const IdleTimerProvider: React.FC<IdleTimerProviderProps> = ({
  children,
  ...options
}) => {
  const timer = useIdleTimer(options);

  return (
    <IdleTimerContext.Provider value={timer}>
      {children}
    </IdleTimerContext.Provider>
  );
};

export const useIdleTimerContext = (): IdleTimerContextValue => {
  const context = useContext(IdleTimerContext);
  if (!context) {
    throw new Error(
      'useIdleTimerContext must be used within an IdleTimerProvider',
    );
  }
  return context;
};

/**
 * Safe version of useIdleTimerContext that returns null if context is not available.
 * Use this when the component might be used outside of IdleTimerProvider.
 */
export const useIdleTimerContextSafe = (): IdleTimerContextValue | null => {
  const context = useContext(IdleTimerContext);
  return context;
};
